// Btn — univerzalne tlacidlo s variantami z ustavy 21.15
//   add    = zelena (pridat, ulozit, OK)
//   delete = cervena (zmazat, destruktivne) — vzdy s potvrdenim
//   nav    = modra (navigacia, otvorit detail)
//   total  = amber (finalny sucet, primary akcia)
//   ghost  = bez vyplne (sekundarna akcia)
//   danger = alias delete (jasnejsi v kontexte)
//
// Aliasy: <BtnAdd>, <BtnDelete>, <BtnNav>, <BtnTotal>, <BtnGhost>, <BtnDanger>
// Vsetky maju modry focus outline (ustava 54.6).

import React from 'react'
import { COLORS, RADIUS, TYPO, SPACE, FOCUS_OUTLINE, FOCUS_OFFSET } from '../theme.js'

// vzhlad_predajne_v1 (61.10): hover o tón tmavší než farby Predajne
const VARIANTS = {
  add:    { bg: COLORS.add,    fg: '#fff', border: COLORS.add,    hover: '#166534' },
  delete: { bg: COLORS.remove, fg: '#fff', border: COLORS.remove, hover: '#991B1B' },
  danger: { bg: COLORS.remove, fg: '#fff', border: COLORS.remove, hover: '#991B1B' },
  nav:    { bg: COLORS.nav,    fg: '#fff', border: COLORS.nav,    hover: '#1E40AF' },
  total:  { bg: COLORS.total,  fg: '#fff', border: COLORS.total,  hover: '#92400e' },
  ghost:  { bg: 'transparent', fg: COLORS.text, border: COLORS.line, hover: COLORS.hover }
}

// Pri načítaní točiaci sa krúžok (bez emoji, ústava); CSS sa do stránky vloží raz.
const SPIN_ID = 'km-btn-spin-css'
function spinCss() {
  if (typeof document === 'undefined' || document.getElementById(SPIN_ID)) return
  const s = document.createElement('style')
  s.id = SPIN_ID
  s.textContent = '@keyframes kmBtnSpin{to{transform:rotate(360deg)}}.km-btn-spin{display:inline-block;width:.8em;height:.8em;box-sizing:border-box;border:2px solid currentColor;border-right-color:transparent;border-radius:50%;vertical-align:-.1em;animation:kmBtnSpin .8s linear infinite}@media (prefers-reduced-motion: reduce){.km-btn-spin{animation:none}}'
  document.head.appendChild(s)
}

const SIZES = {
  sm: { padding: '4px 10px', fontSize: TYPO.sizes.sm, height: 24 },
  md: { padding: '6px 14px', fontSize: TYPO.sizes.base, height: 30 },
  lg: { padding: '10px 20px', fontSize: TYPO.sizes.md, height: 38 }
}

export function Btn({
  variant = 'ghost',
  size = 'md',
  type = 'button',
  disabled = false,
  loading = false,
  fullWidth = false,
  icon = null,
  children,
  onClick,
  style = {},
  title,
  ...rest
}) {
  const v = VARIANTS[variant] || VARIANTS.ghost
  const sz = SIZES[size] || SIZES.md
  const [hover, setHover] = React.useState(false)
  const [focus, setFocus] = React.useState(false)

  const baseStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: SPACE.xs,
    padding: sz.padding,
    height: sz.height,
    fontSize: sz.fontSize,
    fontWeight: TYPO.weights.semibold,
    fontFamily: 'inherit',
    color: v.fg,
    background: hover && !disabled ? v.hover : v.bg,
    border: `1px solid ${v.border}`,
    borderRadius: RADIUS.md,
    cursor: disabled || loading ? 'not-allowed' : 'pointer',
    opacity: disabled ? 0.5 : 1,
    transition: 'background 120ms ease, transform 80ms ease',
    width: fullWidth ? '100%' : 'auto',
    outline: focus ? FOCUS_OUTLINE : 'none',
    outlineOffset: FOCUS_OFFSET,
    userSelect: 'none',
    whiteSpace: 'nowrap',
    ...style
  }

  if (loading) spinCss()
  return (
    <button
      type={type}
      disabled={disabled || loading}
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onFocus={() => setFocus(true)}
      onBlur={() => setFocus(false)}
      title={title}
      style={baseStyle}
      {...rest}
    >
      {loading && <span className="km-btn-spin" aria-hidden style={{ marginRight: SPACE.xs }} />}
      {icon && !loading && <span aria-hidden>{icon}</span>}
      {children}
    </button>
  )
}

// Pomenovane aliasy
export const BtnAdd    = (props) => <Btn variant="add"    {...props} />
export const BtnDelete = (props) => <Btn variant="delete" {...props} />
export const BtnDanger = (props) => <Btn variant="danger" {...props} />
export const BtnNav    = (props) => <Btn variant="nav"    {...props} />
export const BtnTotal  = (props) => <Btn variant="total"  {...props} />
export const BtnGhost  = (props) => <Btn variant="ghost"  {...props} />

export default Btn
